import type { Module } from '@pc/core';
import { lazyWithReload } from '@pc/ui';

const ProductsListPage = lazyWithReload(() => import('./pages/ProductsListPage'));
const ProductDetailPage = lazyWithReload(() => import('./pages/ProductDetailPage'));
const ProductNewPage = lazyWithReload(() => import('./pages/ProductNewPage'));
const ProductsDashboardWidget = lazyWithReload(
  () => import('./widgets/ProductsDashboardWidget'),
);

export const productsModule: Module = {
  id: 'products',
  name: 'Products',
  description:
    'Org-level product catalog with per-store entitlements, per-store pricing (cost / wholesale / retail), and lot tracking.',
  basePath: '/products',
  routes: [
    { path: '/', element: <ProductsListPage /> },
    { path: '/new', element: <ProductNewPage /> },
    { path: '/:id', element: <ProductDetailPage /> },
  ],
  navItems: [{ label: 'Products', to: '/products', order: 15 }],
  dashboardWidgets: [
    {
      id: 'products-summary',
      span: 1,
      order: 30,
      render: ProductsDashboardWidget,
    },
  ],
};
